// @ts-nocheck
import parse from "html-react-parser";
import { useState } from "react";
import { Accordion } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";
import { standardDateTimeFormat } from "utils/timeUtils";

import DeleteNoteModal from "./DeleteNote.modal";

const Note = ({
  note,
  note_type,
  openNoteModal,
  selectedNotes,
  setSelectedNotes,
  allowReplies,
}) => {
  const { currentUser, permissions } = useAuth();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [toDeleteNote, setToDeleteNote] = useState(null);

  const isNiapOrNoteCreator =
    permissions.role_type === "NIAP" || currentUser.id === note.submitted_by.id;

  const visibilityText = (note) => {
    const visibilityTypes = [];
    if (note.internal_only) {
      return "Private";
    }

    // we need to add this check in for PP/AM notes because they aren't using the visibility types, just internal_only
    // so if it doesn't get caught by the internal_only check, then it should show public
    if (
      note_type === "protection_profile" ||
      note_type === "assurance_maintenance"
    ) {
      return "Public";
    }

    if (note.visible_to_labs) {
      visibilityTypes.push("Visible to Labs");
    }

    if (note.visible_to_validators) {
      visibilityTypes.push("Visible to Validators");
    }

    if (note.visible_to_smes) {
      visibilityTypes.push("Visible to SMEs");
    }

    return visibilityTypes.length > 0
      ? visibilityTypes.join(", ")
      : "Visible to NIAP";
  };

  const openDeleteModalHandler = (note) => {
    setToDeleteNote(note);
    setShowDeleteModal(true);
  };

  return (
    <>
      <div className="text-end mx-3">
        {allowReplies && (
          <button
            className="btn btn-link d-inline-block py-1"
            style={{ minWidth: 10 }}
            onClick={() => openNoteModal(note, null)}
            data-cy="reply-note-button"
          >
            Reply
          </button>
        )}

        {isNiapOrNoteCreator && (
          <>
            <button
              className="btn btn-link d-inline-block py-1"
              style={{ minWidth: 10 }}
              data-cy="edit-note-button"
              onClick={() => openNoteModal(null, note)}
            >
              Edit
            </button>
            <button
              className="btn btn-link d-inline-block py-1"
              style={{ minWidth: 10 }}
              data-cy="delete-note-button"
              onClick={() => openDeleteModalHandler(note)}
            >
              Delete
            </button>
          </>
        )}
      </div>
      <div className="border border-secondary p-4 m-4 mt-0">
        <p className="text-end mb-0">
          Note by: {note.submitted_by?.first_name}{" "}
          {note.submitted_by?.last_name} <br />
          {standardDateTimeFormat(note?.submitted_on)}
        </p>
        {note?.note_type !== "ear-review" && (
          <p
            className="text-end"
            data-cy={`note-visibility-${note_type}-${note.note_id}`}
          >
            Visibility: {visibilityText(note)}
          </p>
        )}
        <p className="fw-bold text-break word-wrap">{note.title}</p>
        <div className="text-break word-wrap">
          {note.note && parse(note.note)}
        </div>
        {note.responses && note.responses.length > 0 && (
          <Accordion
            defaultActiveKey={note.note_id}
            activeKey={selectedNotes}
            onSelect={() => {
              const uniqueNotes = new Set(selectedNotes);
              if (uniqueNotes.has(note.note_id)) {
                uniqueNotes.delete(note.note_id);
              } else {
                uniqueNotes.add(note.note_id);
              }
              setSelectedNotes([...uniqueNotes]);
            }}
          >
            <Accordion.Item eventKey={note.note_id}>
              <Accordion.Header>
                {note.responses.length} Responses
              </Accordion.Header>
              <Accordion.Body>
                {note.responses.map((response) => (
                  <div key={response.note_id} className="ms-4">
                    <Note
                      note={response}
                      note_type={note_type}
                      openNoteModal={openNoteModal}
                      selectedNotes={selectedNotes}
                      setSelectedNotes={setSelectedNotes}
                      allowReplies={allowReplies}
                    />
                  </div>
                ))}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
      </div>
      {showDeleteModal && (
        <DeleteNoteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          note={toDeleteNote}
        />
      )}
    </>
  );
};

export default Note;
